import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import Section from '../Inputs/Section'
import { Form, Grid, Header } from 'semantic-ui-react'
import Select from '../Inputs/Select'
import Input from '../Inputs/Input'
import TextArea from '../Inputs/TextArea'
import { observer } from 'mobx-react'
import Checkbox from '../Inputs/Checkbox'

@observer
class RIANFPA000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry),
    changeMenuType: PropTypes.func.isRequired
  }

  componentDidMount () {
    const { changeMenuType } = this.props
    changeMenuType('search', {
      label: 'Rechercher déficiences par alinéa ou # du système',
      enableShowAll: true,
      searchFields: [
        { fieldName: 'alinea', isFixed: true },
        { fieldName: 'numSystem', isFixed: true }
      ]
    })
  }

  render () {
    const { equipment } = this.props
    return (
      <Form style={{ pageBreakInside: 'avoid' }}>
        <Section
          title={(<Header as='h2'>DÉFICIENCES</Header>)} secondaryField={(
            <>
              <Checkbox name='verified' formEntry={equipment} label='Vérifié' />
              <Form.Group widths='equal'>
                <Select
                  name='radMineurMajeur' formEntry={equipment} options={[
                    { value: 'min', text: 'Non-critique' },
                    { value: 'maj', text: 'Critique' },
                    { value: 'hs', text: 'Hors-service' }
                  ]}
                />
                <Select
                  name='nfpa' formEntry={equipment} options={[
                    { value: 'nfpa25', text: 'NFPA 25' },
                    { value: 'nfpa13', text: 'NFPA 13' },
                    { value: 'commentaire', text: 'Commentaire' }]}
                />
              </Form.Group>
            </>)}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <Input name='section' formEntry={equipment} label='Section' />
                <Input name='alinea' formEntry={equipment} label='Alinéa' />
                <Input name='numSystem' formEntry={equipment} label='# du système' />
              </Grid.Column>
              <Grid.Column width={12}>
                <TextArea name='note' formEntry={equipment} label='Note' rows={10} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
      </Form>
    )
  }
}

export default RIANFPA000
